const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
const REACT_APP_WEBHOOK_BASE_URL = process.env.REACT_APP_WEBHOOK_BASE_URL;
const REACT_APP_ENV = process.env.REACT_APP_ENV;
const REACT_APP_PELPAY_BASE_URL_STAGING = process.env.REACT_APP_PELPAY_BASE_URL_STAGING;
const REACT_APP_PELPAY_BASE_URL_PROD = process.env.REACT_APP_PELPAY_BASE_URL_PROD;
const REACT_APP_CARDINAL_URL_STAGING = process.env.REACT_APP_CARDINAL_URL_STAGING;
const REACT_APP_CARDINAL_URL_PROD = process.env.REACT_APP_CARDINAL_URL_PROD;

export const baseQueryUrl = () => {
  let baseUrl = REACT_APP_BASE_URL;
  return baseUrl;
};

export const baseWebhookUrl = () => {
  let baseUrl = REACT_APP_WEBHOOK_BASE_URL
  return baseUrl;
};

export const ProjectEnvironment = REACT_APP_ENV || "dev";

export const PELPAY_BASE_URL =
  ProjectEnvironment === "dev"
    ? REACT_APP_PELPAY_BASE_URL_STAGING
    : REACT_APP_PELPAY_BASE_URL_PROD 

export const cardinalUrl = async () => {
  let url =  ProjectEnvironment === "dev"
  ? REACT_APP_CARDINAL_URL_STAGING
  : REACT_APP_CARDINAL_URL_PROD
  return url;
};


